import { BOINCENSCH_INIT_LOADING, BOINCENSCH_INIT_SUCCESS, BOINCENSCH_INIT_FAIL, BOINCENSCHEME_INIT_LOADING, BOINCENSCHEME_INIT_SUCCESS, BOINCENSCHEME_INIT_FAIL,
  SECTOR_INIT_LOADING, SECTOR_INIT_SUCCESS, SECTOR_INIT_FAIL, DIVISION_INIT_LOADING, DIVISION_INIT_SUCCESS, DIVISION_INIT_FAIL, DIVISION_COMMIT_KEY,
  TEAM_INIT_LOADING, TEAM_INIT_SUCCESS, TEAM_INIT_FAIL, TEAM_COMMIT_KEY, ARM_INIT_LOADING, ARM_INIT_SUCCESS, ARM_INIT_FAIL } from '@/store/types'
import http from '@/utils/ajax'
import clone from 'clone'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  boIncenScheme: {
    init: 0,
    initErr: [],
    menu: {}
  },
  sector: {
    init: 0,
    initErr: [],
    menu: {}
  },
  arm: {
    init: 0,
    initErr: [],
    menu: {}
  },
  division: {
    init: 0,
    initErr: [],
    menu: {},
    divisionId: {
      division: null,
      sector: null,
      divisionDesc: null,
      tranMode: null
    }
  },
  team: {
    init: 0,
    initErr: [],
    menu: {},
    teamId: {
      team: null,
      division: null,
      sector: null,
      teamDesc: null,
      tranMode: null
    }
  }
}

const getters = {

}

const mutations = {
  [BOINCENSCH_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [BOINCENSCH_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [BOINCENSCH_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [BOINCENSCHEME_INIT_LOADING](state) {
    state.boIncenScheme.init = 0
    state.boIncenScheme.menu = {}
    state.boIncenScheme.initErr = []
  },
  [BOINCENSCHEME_INIT_SUCCESS](state, data) {
    state.boIncenScheme.init = 1
    state.boIncenScheme.menu = data ? data.menu : null
    state.boIncenScheme.initErr = []
  },
  [BOINCENSCHEME_INIT_FAIL](state, err) {
    state.boIncenScheme.init = 2
    state.boIncenScheme.menu = {}
    state.boIncenScheme.initErr = err
  },
  [SECTOR_INIT_LOADING](state) {
    state.sector.init = 0
    state.sector.menu = {}
    state.sector.initErr = []
  },
  [SECTOR_INIT_SUCCESS](state, data) {
    state.sector.init = 1
    state.sector.menu = data ? data.menu : null
    state.sector.initErr = []
  },
  [SECTOR_INIT_FAIL](state, err) {
    state.sector.init = 2
    state.sector.menu = {}
    state.sector.initErr = err
  },
  [DIVISION_INIT_LOADING](state) {
    state.division.init = 0
    state.division.menu = {}
    state.division.initErr = []
  },
  [DIVISION_INIT_SUCCESS](state, data) {
    state.division.init = 1
    state.division.menu = data.menu
    state.division.initErr = []
  },
  [DIVISION_INIT_FAIL](state, err) {
    state.division.init = 2
    state.division.menu = {}
    state.division.initErr = err
  },
  [DIVISION_COMMIT_KEY](state, data) {
    state.division.divisionId.division = data.division
    state.division.divisionId.sector = data.sector
    state.division.divisionId.divisionDesc = data.divisionDesc
    state.division.divisionId.tranMode = data.tranMode
  },
  [TEAM_INIT_LOADING](state) {
    state.team.init = 0
    state.team.menu = {}
    state.team.initErr = []
  },
  [TEAM_INIT_SUCCESS](state, data) {
    state.team.init = 1
    state.team.menu = data.menu
    state.team.initErr = []
  },
  [TEAM_INIT_FAIL](state, err) {
    state.team.init = 2
    state.team.menu = {}
    state.team.initErr = err
  },
  [TEAM_COMMIT_KEY](state, data) {
    state.team.teamId.team = data.team
    state.team.teamId.division = data.division
    state.team.teamId.sector = data.sector
    state.team.teamId.teamDesc = data.teamDesc
    state.team.teamId.tranMode = data.tranMode
  },
  [ARM_INIT_LOADING](state) {
    state.arm.init = 0
    state.arm.menu = {}
    state.arm.initErr = []
  },
  [ARM_INIT_SUCCESS](state, data) {
    state.arm.init = 1
    state.arm.menu = data ? data.menu : null
    state.arm.initErr = []
  },
  [ARM_INIT_FAIL](state, err) {
    state.arm.init = 2
    state.arm.menu = {}
    state.arm.initErr = err
  }
}

const actions = {
  async boIncenSchManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.boIncenSchManagement
    commit(BOINCENSCH_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(BOINCENSCH_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(BOINCENSCH_INIT_FAIL, extractMessages(error))
      }
    }
  },
  async boIncenSchemeInit({ commit, rootState }) {
    const apiUrl = rootState.boIncenSchParam.menu.boIncenSchemeInit
    commit(BOINCENSCHEME_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(BOINCENSCHEME_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(BOINCENSCHEME_INIT_FAIL, extractMessages(error))
    }
  },
  async sectorInit({ commit, rootState }) {
    const apiUrl = rootState.boIncenSchParam.menu.sectorInit
    commit(SECTOR_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(SECTOR_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(SECTOR_INIT_FAIL, extractMessages(error))
    }
  },
  async divisionInit({ commit, rootState }) {
    const apiUrl = rootState.boIncenSchParam.menu.divisionInit
    commit(DIVISION_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(DIVISION_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(DIVISION_INIT_FAIL, extractMessages(error))
    }
  },
  async teamInit({ commit, rootState }) {
    const apiUrl = rootState.boIncenSchParam.menu.teamInit
    commit(TEAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TEAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(TEAM_INIT_FAIL, extractMessages(error))
    }
  },
  async armInit({ commit, rootState }) {
    const apiUrl = rootState.boIncenSchParam.menu.armInit
    commit(ARM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ARM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ARM_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
